import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from '../../../environments/environment';
import { AppService } from "../../app.service";

@Injectable()
export class NavBarGuard implements Resolve<any> {

    constructor(
        private appService: AppService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {

        return new Promise(resolve => {

            try {
                const token = (localStorage.getItem('token') || sessionStorage.getItem('token'));
                let user = this.appService.getUser().value;

                this.appService.user.subscribe((_user) => {

                    if (user || _user) {
                        resolve(user || _user);
                    }

                    if ((!_user && !user) || !token) {
                        resolve(false);
                    }

                });

            } catch (e) {
                resolve(false);
            }
        });
    }
}
